export default __webpack_public_path__ + "static/media/coding_image.e50e69cb.jpg";